import { isEmpty } from 'lodash-es';
import {
  ListingGroupItemInput,
  ListingGroupUndercutSetting,
} from 'src/WebApiController';

const sanitizeNumber = (value: number | null): number | null => {
  if (value == null) {
    return null;
  }
  return Math.round(value * 100) / 100;
};

export const withGroupUndercustSettings = (
  groupUndercutSetting: ListingGroupUndercutSetting | null,
  listingGroupItems: ListingGroupItemInput[]
): ListingGroupItemInput[] => {
  if (isEmpty(listingGroupItems)) {
    return listingGroupItems;
  }
  const { undAbsAmt, undRelAmt } = groupUndercutSetting ?? {};
  return listingGroupItems.map((listing, index): ListingGroupItemInput => {
    const undercutSetting: ListingGroupUndercutSetting = {
      undAbsAmt: undAbsAmt ? sanitizeNumber(undAbsAmt * index) : null,
      undRelAmt: undRelAmt
        ? sanitizeNumber(Math.min(undRelAmt * index, 1))
        : null,
      actRankUndAbsAmt: null,
      actRankUndRelAmt: null,
    };
    return {
      ...listing,
      undercutSetting,
    };
  });
};
